
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import GoogleMapsLinkInput from '../GoogleMapsLinkInput';
import AiFilledNotification from '../AiFilledNotification';

interface FormInputSectionProps {
  isProcessingLink: boolean;
  setIsProcessingLink: (loading: boolean) => void;
  onLinkProcessed: (success: boolean, data?: any) => void;
  onReset: () => void;
  isAiFilled: boolean;
}

const FormInputSection: React.FC<FormInputSectionProps> = ({
  isProcessingLink,
  setIsProcessingLink,
  onLinkProcessed,
  onReset,
  isAiFilled
}) => {
  return (
    <Card>
      <CardContent className="p-6">
        <div className="mt-6">
          <GoogleMapsLinkInput
            isProcessingLink={isProcessingLink}
            setIsProcessingLink={setIsProcessingLink}
            onLinkProcessed={onLinkProcessed}
            onReset={onReset}
            showReset={isAiFilled}
          />
        </div>
        
        {isAiFilled && (
          <AiFilledNotification onReset={onReset} />
        )}
      </CardContent>
    </Card>
  );
};

export default FormInputSection;
